export const RESET_UI_STATE = "RESET_UI_STATE";
export const SET_CONNECTION_TYPE = "SET_CONNECTION_TYPE";
export const START_FETCHING = "START_FETCHING";
export const STOP_FETCHING = "STOP_FETCHING";
export const EMIT_ERROR = "EMIT_ERROR";
export const RESET_ERROR = "RESET_ERROR";
export const SAVE_SNACKBAR_TEXT = "SAVE_SNACKBAR_TEXT";
export const SET_PAGE_LOADING = "START_PAGE_LOADING";
